import classNames from 'classnames';

import { MaskedField } from './MaskedField';

interface MaskDefinition {
  ckType: 'unknown' | 'phone' | 'email';
  mask: string | RegExp;
  definitions?: {
    [key: string]: RegExp;
  };
}

export interface StickyInputProps {
  id: string;
  name: string;
  type: string;
  style?: string;
  placeholder: string;
  mask: MaskDefinition[];
  dispatch: (appended: any, masked: any, flags: any) => any;
  error?: any;
}

export default function StickyInput(props: StickyInputProps) {
  return (
    <div className="relative">
      <MaskedField
        {...props}
        id={props.id}
        name={props.id}
        placeholder=" " // for placeholder animation hack
        autoComplete={'off'}
        className={classNames(
          'block w-full p-3 bg-white rounded-lg appearance-none peer',
          'text-base text-opaque-navy',
          'border border-solid border-opaque-navy-border',
          'focus:text-black focus:bg-white focus:border-primary-blue focus:outline-one',
          'transition ease-in-out'
        )}
      />
      <label
        htmlFor={props.id}
        className="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-primary-blue peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
      >
        {props.placeholder}
      </label>
    </div>
  );
}
